import Vue from 'vue'
import Vuex from 'vuex'

import cloudMining from './cloud-mining';
import issuers from './issuers'
import product from './product'
import contracts from './contracts'
import blockchain from './blockchain'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedCoins: ['BTC'],
    favorites: JSON.parse(localStorage.getItem('favorites') || '[]')
  },
  mutations: {
    toggleFavorites(state, id) {
      if (state.favorites.indexOf(id) < 0) {
        state.favorites.push(id);
      } else {
        state.favorites = state.favorites.filter(v => v !== id);
      }

      localStorage.setItem('favorites', JSON.stringify(state.favorites));
    }
  },
  actions: {
    async init({ dispatch }) {
      dispatch('blockchain/load');
    }
  },
  modules: {
    cloudMining,
    contracts,
    issuers,
    blockchain,
    product
  }
})
